import React from "react";
import "./Contact.css";

const Contact = () => (
  <div className="contact-page">
    <section className="services-hero-modern">
      <div className="container">
        <h1>Contact Us</h1>
        <p>
          Reach out to the Toora Flex team. Start a support conversation and
          follow replies using your private ticket link.
        </p>
      </div>
    </section>

    <section className="section-padding">
      <div className="container contact-support-container">
        <div className="contact-info contact-support-details">
          <h3>Get in Touch</h3>
          <p className="contact-chat-intro">
            Need help? Start a secure conversation with our support team.
          </p>
          <button
            type="button"
            className="contact-chat-button"
            onClick={() => window.dispatchEvent(new Event("toora:open-support-chat"))}
          >
            <i className="fas fa-comments" aria-hidden="true" />
            Start a conversation
          </button>
          <div className="contact-detail">
            <i className="fas fa-map-marker-alt" />
            <div>
              <h4>Visit Our Office</h4>
              <p>012 Central, 367 Helen Joseph Street, Pretoria CBD</p>
            </div>
          </div>
          <div className="contact-detail">
            <i className="fas fa-phone-alt" />
            <div>
              <h4>Call Us</h4>
              <p><a href="tel:+27664575904">+27 66 457 5904</a></p>
            </div>
          </div>
          <div className="contact-detail">
            <i className="fas fa-envelope" />
            <div>
              <h4>Email Us</h4>
              <p><a href="mailto:info@tooraflex.co.za">info@tooraflex.co.za</a></p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
);

export default Contact;
